import { __extends } from "tslib";
import * as React from 'react';
import * as common from 'markdown-tip';
export * from 'markdown-tip';
/**
 * @public
 */
var MarkdownTip = /** @class */ (function (_super) {
    __extends(MarkdownTip, _super);
    function MarkdownTip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visibleText = null;
        _this.titleClass = common.defaultTitleClass;
        return _this;
    }
    MarkdownTip.prototype.render = function () {
        var _this = this;
        var datas = common.getLocale(this.props.locale);
        var items = datas.map(function (data, i) {
            var title = data.text === _this.visibleText ? React.createElement("pre", { className: _this.titleClass }, data.title) : null;
            return (React.createElement("div", { className: 'markdown-tip-item', key: i, onMouseEnter: function (e) { return _this.mouseenter(data, e); }, onMouseLeave: function (e) { return _this.mouseleave(data); } },
                React.createElement("span", { className: 'markdown-tip-item-text' }, data.text),
                title));
        });
        return (React.createElement("div", { className: 'markdown-tip' }, items));
    };
    MarkdownTip.prototype.mouseenter = function (data, event) {
        this.visibleText = data.text;
        this.titleClass = common.getTitleClass(event.target);
        this.setState({ visibleText: this.visibleText, titleClass: this.titleClass });
    };
    MarkdownTip.prototype.mouseleave = function (data) {
        this.visibleText = null;
        this.setState({ visibleText: this.visibleText });
    };
    return MarkdownTip;
}(React.PureComponent));
export { MarkdownTip };
